<div ngModelGroup="address">

  <!--Prefix-->
  <div class="pos-relative">
    <input-wrap>
    <select class="input"
      name="prefix"
      [(ngModel)]="data.prefix"
      [muiInput]="'Title'| translate"
      required>
      @for (prefix of prefixes; track prefix) {
        <option
          [value]="prefix">
          {{prefix}}
        </option>
      }
    </select>
  </input-wrap>
</div>

<!--First name-->
<div class="pos-relative m-t-9">
  <input-wrap>
  <input class="input"
    type="text"
    name="firstname"
    cy-addressAddFname
    autocomplete="given-name"
    [(ngModel)]="data.firstname"
    required
    [muiInput]="('First Name' | translate)"
    maxlength="100">
</input-wrap>
</div>
<!-- Last name -->
<div class="pos-relative m-t-9">
  <input-wrap>
  <input class="input"
    type="text"
    name="lastname"
    cy-addressAddLname
    autocomplete="family-name"
    [(ngModel)]="data.lastname"
    required
    [muiInput]="('Last name' | translate)"
    maxlength="50">
</input-wrap>
</div>

<!-- Nickname-->
<div class="pos-relative m-t-9">
  <input-wrap>
  <input class="input"
    type="text"
    name="nickname"
    cy-addressAddNickname
    [(ngModel)]="data.nickname"
    [muiInput]="('Give this address a nickname' | translate)">
</input-wrap>
</div>

<!--Country-->
<div class="pos-relative m-t-9">
  <input-wrap class="input-wrap">
  <select class="input"
    name="country"
    cy-addressAddCountry
    autocomplete="country"
    [(ngModel)]="data.country_id"
    (change)="onCountryChange()"
    [muiInput]="('Country' | translate)"
    required>
    @for (country of countries | orderBy: ['name']; track country) {
      <option
      [value]="country.code">{{country.name}}</option>
    }
  </select>
</input-wrap>
</div>

<!-- searcher -->
@if (searcher && !isInEditor) {
  <div class="pos-relative m-t-9"
    (offClick)="searcher.clear()"
    [offClickOff]="!searcher.hints.length">
    <input-wrap [ngClass]="{'is-busy': searcher.status.busy}">
    <input class="input"
      type="text"
      name="query"
      autocomplete="off"
      [muiInput]="('Search for address or postcode' | translate)"
      [(ngModel)]="searcher.query"
      (keydown.enter)="searcher.search()"
      (focus)="searcher.search()">
    @if (searcher.status.busy) {
      <span class="pos-absolute top-0 right-2 bottom-0 flex flex-middle flex-justify-center pe-none"
        >
        <i class="icon-loading"></i>
      </span>
    }
    <!-- open -->
    <div class="hide-up-container pos-absolute left-0 right-0">
      <div class="ng-hide-animate hide-up bg-col-w z-3 b-a b-t-0 overflow-y-scroll"
        [class.ng-hide]="!searcher.hints?.length"
        style="max-height: 20em;"
        role="listbox"
        [attr.aria-hidden]="!searcher.hints?.length"
        [attr.tabindex]="searcher.hints?.length ? 0 : -1">
        <ul>
          @for (hint of searcher.hints; track searcher.trackByHint($index, hint)) {
            <li role="option"
              (click)="searcher.search(hint)"
              >
              <button type="button"
                class="p-a-2 w-12 left">
                <p class="p2">{{hint['Text']}} {{hint['Description']}}</p>
              </button>
            </li>
          }
        </ul>
      </div>
    </div>
  </input-wrap>
</div>
}

<!-- toggle enter address manually -->
@if (searcher && !isInEditor) {
  <toggle
    class="m-t-6 m-b-1 block fs-4"
    name="address"
    cy-addressAddUnfold
    [(ngModel)]="displayFormLocal">
    <span class="p1"
    translate>Enter address manually</span>
  </toggle>
}

<div class="address-fieldset"
  [ngClass]="{'ng-hide' : !displayFormLocal && !isInEditor}">

  <!-- Address line 1 -->
  <div class="pos-relative m-t-9-s"
    [ngClass]="searcher && !isInEditor ? 'm-t-6' : 'm-t-9'">
    <input-wrap>
    <input class="input"
      type="text"
      name="street_1"
      cy-addressAddFirstLine
      autocomplete="address-line1"
      [(ngModel)]="data.street_1"
      required
      [muiInput]="('Address line 1' | translate)"
      maxlength="100">
  </input-wrap>
</div>

<!-- Address line 2 -->
<div class="pos-relative m-t-9">
  <input-wrap>
  <input class="input"
    type="text"
    name="street_2"
    cy-addressAddSecondLine
    autocomplete="address-line2 address-line-3"
    [(ngModel)]="data.street_2"
    [muiInput]="('Address line 2' | translate)"
    maxlength="50">
</input-wrap>
</div>

<!-- City -->
<div class="pos-relative m-t-9">
  <input-wrap>
  <input class="input"
    type="text"
    name="city"
    cy-addressAddCity
    autocomplete="address-level2 address-level3 address-level4"
    [(ngModel)]="data.city"
    required
    [muiInput]="('Town/City' | translate)"
    maxlength="30">
</input-wrap>
</div>

<!-- Post Code-->
<div class="pos-relative m-t-9">
  <input-wrap>
  <input class="input"
    type="text"
    name="postcode"
    cy-addressAddPostcode
    autocomplete="postal-code"
    [(ngModel)]="data.postcode"
    required
    [muiInput]="('Postcode' | translate)"
    maxlength="20">
</input-wrap>
</div>

<!--Region-->
@if (regionRequired) {
  <div
    class="pos-relative m-t-9">
    @if (!regions) {
      <input-wrap>
      <input class="input"
        type="text"
        name="region"
        cy-addressAddRegion
        autocomplete="address-level1"
        [(ngModel)]="data.region"
        [required]="regionRequired"
        [muiInput]="('Region' | translate)">
    </input-wrap>
  }
  @if (regions) {
    <input-wrap>
    <select class="input"
      name="region_id"
      cy-addressAddRegionId
      autocomplete="address-level1"
      [(ngModel)]="data.region_id"
      [required]="regionRequired"
      [muiInput]="('Region' | translate)">
      <option value=""></option>
      @for (region of regions | orderBy: ['name']; track trackByCode($index, region)) {
        <option
        [value]="region.id">{{region.name}}</option>
      }
    </select>
  </input-wrap>
}
</div>
}
</div>

<!--Phone-->
<div class="pos-relative m-t-9-s"
  [ngClass]="searcher && !isInEditor && !displayFormLocal ? 'm-t-6' : 'm-t-9'">
  <input-wrap>
  <input class="input"
    type="text"
    name="telephone"
    validatePattern="telephone"
    inputmode="numeric"
    cy-addressAddPhone
    autocomplete="tel"
    [(ngModel)]="telephoneNumber"
    required
    #phoneInput
    [muiInput]="('Phone number' | translate)"
    maxlength="30">
</input-wrap>
</div>

</div>